//DO NOT DELETE, THIS IS AN APP GENERATED FILE 
//IF YOU DELETE THIS FILE IT WILL EFFECT THE PRICES OF THE PRODUCT 
const backupprices = [
    {
      pricing: {
        '30x40': {
          price: 63.99,
          salePrice: 51.19,
          single: 29.99
        },
        '40x50': {
          price: 79.99,
          salePrice: 63.99,
          single: 34.99
        },
        '50x70': {
          price: 99.99,
          salePrice: 79.99,
          single: 39.99
        },
        '70x100': {
          price: 139.99,
          salePrice: 111.99,
          single: 59.99
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 63.99,
          salePrice: 51.19,
          single: 29.99
        },
        '40x50': {
          price: 79.99,
          salePrice: 63.99,
          single: 34.99
        },
        '50x70': {
          price: 99.99,
          salePrice: 79.99,
          single: 39.99
        },
        '70x100': {
          price: 139.99,
          salePrice: 111.99,
          single: 59.99
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 63.99,
          salePrice: 51.19,
          single: 29.99
        },
        '40x50': {
          price: 79.99,
          salePrice: 63.99,
          single: 34.99
        },
        '50x70': {
          price: 99.99,
          salePrice: 79.99,
          single: 39.99
        },
        '70x100': {
          price: 139.99,
          salePrice: 111.99,
          single: 59.99
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 33.99,
          salePrice: 27.19,
          single: 0
        },
        '40x50': {
          price: 44.99,
          salePrice: 35.99,
          single: 0
        },
        '50x70': {
          price: 59.99,
          salePrice: 47.99,
          single: 0
        },
        '70x100': {
          price: 79.99,
          salePrice: 63.99,
          single: 0
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 63.99,
          salePrice: 51.19,
          single: 29.99
        },
        '40x50': {
          price: 77.99,
          salePrice: 62.39,
          single: 32.99
        },
        '50x70': {
          price: 94.99,
          salePrice: 75.99,
          single: 34.99
        },
        '70x100': {
          price: 119.99,
          salePrice: 95.99,
          single: 39.99
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 63.99,
          salePrice: 51.19,
          single: 29.99
        },
        '40x50': {
          price: 77.99,
          salePrice: 62.39,
          single: 32.99
        },
        '50x70': {
          price: 94.99,
          salePrice: 75.99,
          single: 34.99
        },
        '70x100': {
          price: 119.99,
          salePrice: 95.99,
          single: 39.99
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 63.99,
          salePrice: 51.19,
          single: 29.99
        },
        '40x50': {
          price: 77.99,
          salePrice: 62.39,
          single: 32.99
        },
        '50x70': {
          price: 94.99,
          salePrice: 75.99,
          single: 34.99
        },
        '70x100': {
          price: 119.99,
          salePrice: 95.99,
          single: 39.99
        },
      },
    },
    {
      pricing: {
        '30x40': {
          price: 25.00,
          salePrice: 20.00,
          single: 0
        },
        '40x50': {
          price: 25.00,
          salePrice: 20.00,
          single: 0
        },
        '50x70': {
          price: 25.00,
          salePrice: 20.00,
          single: 0
        },
        '70x100': {
          price: 25.00,
          salePrice: 20.00,
          single: 0
        },
      },
    },
  ];	